import React from 'react';
import './ThemeIcon.scss';

const ThemeIcon = (icon) => {
    return (
        <div className='icon-box'>
            <img src={icon.icon} alt="icon"  loading="lazy" />
        </div>
    );
};

export default ThemeIcon;